// Utility for converting hex color to number for PixiJS
export function hexToPixi(hex: string): number {
  return parseInt(hex.replace('#', ''), 16);
}
